import { create } from 'zustand';

import { EOutputMode, getCreationList } from '@/service/agent';
import type { ICreationItem } from '@/service/agent';

interface ISpaceStore {
  spaceList: ICreationItem[];
  loading: boolean;
  deleteSpaceItem: (id: string) => void;
  updateSpaceItem: (newItem: Partial<ICreationItem>) => void;
  updateSpaceList: (spaceItemList: ICreationItem[]) => void;
  refreshSpaceList: () => void;
}

const useSpaceStore = create<ISpaceStore>()((set, get) => ({
  spaceList: [],
  loading: false,
  updateSpaceItem: (newItem: Partial<ICreationItem>) => {
    const { spaceList } = get();

    if (!newItem.id) return;

    const index = spaceList.findIndex((item) => item.id == newItem.id);

    // 找到则更新，找不到则追加
    const newSpaceList: ICreationItem[] =
      index !== -1
        ? spaceList.map((item) => (item.id == newItem.id ? { ...item, ...newItem } : item))
        : spaceList;

    set({ spaceList: newSpaceList });
  },
  deleteSpaceItem: (id: string) => {
    const { spaceList } = get();
    const newSpaceList = spaceList.filter((item) => item.id.toString() != id);

    set({ spaceList: newSpaceList });
  },
  updateSpaceList: (spaceItemList: ICreationItem[]) => {
    set({ spaceList: spaceItemList });
  },
  refreshSpaceList: () => {
    set({ loading: true });
    getCreationList({
      pageNo: 1,
      pageSize: 100,
      types: [
        EOutputMode.CALL,
        EOutputMode.MSG,
        EOutputMode.MUSIC,
        EOutputMode.SNAP,
        EOutputMode.VIDEO
      ]
    })
      .then((res) => {
        if (res.data.code !== 0) {
          throw new Error(res.data.message);
        }

        get().updateSpaceList(res.data.data.list);
      })
      .finally(() => {
        set({ loading: false });
      });
  }
}));

export default useSpaceStore;
